// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 GET /api/common/center */
export async function commonControllerGetCenterList(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.CommonControllerGetCenterListParams,
	options?: { [key: string]: any }
) {
	return request<API.PaginatedDto & { results?: API.CenterListResponse[] }>(
		'/api/common/center',
		{
			method: 'GET',
			params: {
				// page has a default value: 1
				page: '1',
				// size has a default value: 10
				size: '10',
				...params,
			},
			...(options || {}),
		}
	);
}

/** 此处后端没有提供注释 GET /api/common/download */
export async function commonControllerDownload(options?: {
	[key: string]: any;
}) {
	return request<any>('/api/common/download', {
		method: 'GET',
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/common/download-all-upload-files */
export async function commonControllerDownloadAllUploadFiles(options?: {
	[key: string]: any;
}) {
	return request<any>('/api/common/download-all-upload-files', {
		method: 'GET',
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/common/lock */
export async function commonControllerLock(
	body: API.LockRequest,
	options?: { [key: string]: any }
) {
	return request<any>('/api/common/lock', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/common/lock/${param0} */
export async function commonControllerGetLock(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.CommonControllerGetLockParams,
	body: API.LockResponse,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<any>(`/api/common/lock/${param0}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/common/operationlog/${param0} */
export async function commonControllerGetOperationLog(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.CommonControllerGetOperationLogParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.OperationLogViewResponse[]>(
		`/api/common/operationlog/${param0}`,
		{
			method: 'GET',
			params: { ...queryParams },
			...(options || {}),
		}
	);
}

/** 此处后端没有提供注释 POST /api/common/upload */
export async function commonControllerUploadFile(
	body: {
		name?: string;
	},
	file?: File,
	options?: { [key: string]: any }
) {
	const formData = new FormData();

	if (file) {
		formData.append('file', file);
	}

	Object.keys(body).forEach((ele) => {
		const item = (body as any)[ele];

		if (item !== undefined && item !== null) {
			if (typeof item === 'object' && !(item instanceof File)) {
				if (item instanceof Array) {
					item.forEach((f) => formData.append(ele, f || ''));
				} else {
					formData.append(ele, JSON.stringify(item));
				}
			} else {
				formData.append(ele, item);
			}
		}
	});

	return request<any>('/api/common/upload', {
		method: 'POST',
		data: formData,
		requestType: 'form',
		...(options || {}),
	});
}
